<template>
  <PageSecondary>
    <template #title>Код ревью</template>
    Привет! Супер. Условия бесплатного ревью:
    <ul style="">
      <li>До 100 строк кода на ревью, без учёта объёма всего проекта.</li>
      <li>Хорошо сформулированная задача.</li>
      <li>Код в GIT.</li>
    </ul>
    Если условия выполнены - напиши мне <a href="https://t.me/alanverne" target="_blank">в Telegram</a> описание задачи и ссылку на diff, я уделю 10 минут на ревью.
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";

export default {
  name: "WannaCodeReview",
  components: {PageSecondary}
}
</script>

<style scoped>

</style>
